import { Injectable } from '@angular/core';
import { AssesmentQuizSnapshotUploadPayload } from '@edtech-ui/core/models/assesment/post-snapshot-image';
import { QuizManagementService } from '@edtech-ui/core/services/quiz-management/quiz-management.service';

@Injectable({
	providedIn: 'root'
})
export class SnapshotServiceTsService {

	
  private lastCaptureMap = new Map<string, number>();
  private readonly THROTTLE_MS = 5000;

  constructor(private quizService: QuizManagementService) { }

  capture(
    video: HTMLVideoElement,
    attemptId: string,
    violationType: string,
    warningCount: number
  ): void {
    const now = Date.now();
    const last = this.lastCaptureMap.get(violationType) || 0;
    if (now - last < this.THROTTLE_MS) return;
    this.lastCaptureMap.set(violationType, now);

    const canvas = document.createElement('canvas');
    canvas.width = video.videoWidth || 640;
    canvas.height = video.videoHeight || 480;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(video, 0, 0);

    canvas.toBlob(blob => {
      if (!blob) return;

      const payload: AssesmentQuizSnapshotUploadPayload = {
        attempt_id: attemptId,
        image: blob,
        is_violation: true,
        violation_type: violationType,
        severity: warningCount >= 3 ? 'CRITICAL' : 'WARNING',
        reason: `Detected: ${violationType}`,
        violation_count: warningCount
      };

      this.quizService.postSnapshot(payload).subscribe({
        next: (res) => {
          if (res.Success) {
            console.log('[Snapshot] Uploaded', res.Data.s3_url);
          }
        },
        error: (err) => console.error('[Snapshot] Upload failed ', err)
      });

    }, 'image/jpeg', 0.8);
  }
}